<template>
  <el-dialog
    :visible="true"
    title="申请证书"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="650px"
    @close="onClickClose"
  >
    <div class="content">
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="refApply"
        label-width="105px"
      >
        <el-form-item label="单位名称" prop="deptName">
          <div>{{dataForm.deptName}}</div>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <div>{{dataForm.realName}}</div>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <div>{{dataForm.idCard}}</div>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <div>{{dataForm.mobile}}</div>
        </el-form-item>
        <el-form-item label="考试名称" prop="examName">
           <el-select v-model="dataForm.examName" placeholder="选择考试名称" style="width: 100%;" @change="onChangeExamName">
              <el-option v-for="item in examOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="年度" prop="year">
          <el-date-picker
            v-model="dataForm.year"
            :editable="false"
            type="year"
            value-format="yyyy"
            placeholder="选择年度"
            style="width: 100%;"
            :readonly="true"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <template slot="footer">
      <el-button @click="onClickClose">取消</el-button>
      <el-button type="primary" @click="onClickConfirm" :loading="btnLoading">确认</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        deptName: '',
        realName: '',
        idCard: '',
        mobile: '',
        examName: '',
        year: ''
      },
      dataRule: {
        examName: [
          {
            required: true,
            message: '请选择考试名称',
            trigger: ['blur', 'change']
          }
        ],
        year: [
          {
            required: true,
            message: '请选择年度',
            trigger: ['blur', 'change']
          }
        ]
      },
      examOptions: [],
      btnLoading: false
    }
  },
  methods: {
    onClickClose () {
      this.$emit('click-close')
    },
    onClickConfirm () {
      this.$refs['refApply'].validate((valid) => {
        console.log(valid)
        if (!valid) {
          return false
        } else {
          this.btnLoading = true
          this.$get(`/exam/etofflineexampersonne/applyExamCertificate?libraryId=${this.dataForm.examName}`)
            .then(res => {
              this.btnLoading = false
              const { code = 500, msg } = res
              if (code === 0) {
                this.$message.success(msg)
                this.$emit('click-close')
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      })
    },
    getUserInfo () {
      this.$get('/client/personalCenter/getPersonalInfo').then(res => {
        console.log(res)
        const { code = 500, data } = res
        if (code === 0) {
          this.dataForm.deptName = data?.deptName ?? ''
          this.dataForm.realName = data?.realName ?? ''
          this.dataForm.idCard = data?.idCard ?? ''
          this.dataForm.mobile = data?.mobile ?? ''
        }
      })
    },
    getExamOptions () {
      this.$get('/exam/etofflineexampersonne/getLibraryListByUserId')
        .then(res => {
          const { code = 500, data } = res
          if (code === 0) {
            this.examOptions = data.map(item => {
              return {
                id: item.libraryId,
                name: item.libraryName,
                year: item.year
              }
            })
          }
        })
    },
    onChangeExamName (id) {
      let examIndex = this.examOptions.findIndex(item => item.id === id)
      if (examIndex !== -1) {
        this.dataForm.year = this.examOptions[examIndex].year
      }
    }
  },
  created () {
    this.getExamOptions()
    this.getUserInfo()
  }
}
</script>
<style lang="scss" scoped></style>
